<div id="no_access">
  <div class="no_access_image" *ngIf="payment === 'success'">
    <img src="assets/image/success.png" alt="No Access">
  </div>
  <div class="no_access_image" *ngIf="payment === 'fail'">
    <img src="assets/image/failed.png" alt="No Access">
  </div>
  <div class="no_access_title" *ngIf="payment === 'success'">
    حساب کاربری شما با موفقیت ارتقا یافت.
  </div>
  <div class="no_access_title" *ngIf="payment === 'fail'">
    پرداخت ناموفق بود.
  </div>
  <div class="no_access_cta">
    <a style="cursor: pointer" [routerLink]="['']">برگشت به صفحه اصلی</a>
  </div>
</div>
<app-footer></app-footer>
